import React from 'react'
import PropTypes from 'prop-types'
import classnames from "classnames"
import _ from "lodash"
import { Draggable, Droppable } from "@hello-pangea/dnd"
import DragWrapper from "./field-types/DragWrapper"
import Integer from "./field-types/Integer"
import Text from "./field-types/Text"
import DefaultType from "./field-types/DefaultType"
import EmptySection from "./EmptySection"
import TextArea from "./field-types/TextArea"
import Email from "./field-types/Email"
import Decimal from "./field-types/Decimal"
import Phone from "./field-types/Phone"
import { _logWithFileContext } from '@csrc/utility/Utils'

const FieldsGroup = props => {
  const {groupIndex, group, groupChildren, customFieldsState, entityName, emptyDndDroppableText} = props

  const renderCustomFieldTypeComponent = (item, provided, snapshot) => {
    let Component = 'div'
    switch (item.field_type) {
      case 'text':
        Component = Text
        break
      case 'textarea':
        Component = TextArea
        break
      case 'email':
        Component = Email
        break
      case 'phone':
        Component = Phone
        break
      case 'integer':
        Component = Integer
        break
      case 'decimal':
        Component = Decimal
        break
      default:
        Component = DefaultType
        break
    }
    return <Component data={item} provided={provided} snapshot={snapshot} customFieldsState={customFieldsState} />
  }

  return (
    <div className={'mt-1'}>

      {/*<h4>{group.title}</h4>*/}
      <Droppable key={groupIndex} droppableId={group.key} isDropDisabled={false} isCombineEnabled={false} ignoreContainerClipping={false}>
        {(droppableProvided, droppableSnapshot) => {
          let index = -1
          return (
            <div
              key={groupIndex}
              ref={droppableProvided.innerRef}
              className={classnames(`entity-custom-columns border rounded p-1`)}
              style={{ minHeight: 250 }}
              {...droppableProvided.droppableProps}
            >
              {
                _.size(groupChildren) === 0 ? (
                  <div className={'d-flex justify-content-center'}>
                    <div className={'w-50'}>
                      <EmptySection entityName={entityName} emptyDndDroppableText={emptyDndDroppableText}/>
                    </div>
                  </div>
                ) : (
                  _.map(groupChildren, (entityCustomFieldItem) => {
                    index = index + 1
                    _logWithFileContext('FieldsGroup -> renderCustomFieldTypeComponent -> entityCustomFieldItem', entityCustomFieldItem)
                    return (
                      <Draggable
                        key={`${entityCustomFieldItem.key}`}
                        index={index}
                        className={'flex-1'}
                        draggableId={`__${entityCustomFieldItem?.key}`}
                      >
                        {(draggableProvided, draggableSnapshot) => {
                          // if (draggableSnapshot.isDragging) {
                          // 	const ele = document.getElementsByClassName(`template-${draggableSnapshot.draggingOver}`)[0]
                          // 	if (ele) {
                          // 		ele.classList.add(`depth-${item.depth}`)
                          // 	}
                          // }
                          return (
                            <DragWrapper
                              provided={draggableProvided}
                              dataState={{
                                entityCustomFieldItem,
                                customFieldsState
                              }}
                            >
                              {
                                renderCustomFieldTypeComponent(entityCustomFieldItem, draggableProvided, draggableSnapshot)
                              }
                            </DragWrapper>
                          )
                        }}
                      </Draggable>
                    )
                  })
                )
              }
              {droppableProvided.placeholder}
            </div>
          )
        }}
      </Droppable>
    </div>
  )
}

FieldsGroup.propTypes = {

}

export default FieldsGroup